import { PRODUCTION_PREVIEW_KEY } from "./localStorage";
import memoize from "lodash/memoize";

export const UI_VERSION = "1.4";

export const IS_TOUCH = "ontouchstart" in window;

const isDevelopmentHost = memoize((host: string) => {
  const notProductionPrefixes = ["dev.", "testnet.", "localhost:"];

  return notProductionPrefixes.some((prefix) => {
    return host.startsWith(prefix);
  });
});

export function isDevelopment() {
  const isProductionPreview = Boolean(localStorage.getItem(PRODUCTION_PREVIEW_KEY) === 'true');

  return isDevelopmentHost(window.location.host) && !isProductionPreview;
}

export function isLocal() {
  return window.location.host.startsWith("localhost:");
}
